<template>
  <div class="passenger-seg-list">
    <template v-for="(passenger, index) in passengers">
      <div class="passenger-box" :key="index">
        <div class="pass-header">
          <!-- <span class="h-strong">
            <l8-icon class="l8-icon" type="icon-lvke" /> 旅客{{
              +index + 1
            }}</span
          > -->
          <span class="h-msg">
            <span v-if="passenger.fullName" style="margin-left: 0">{{ passenger.fullName }}</span>
            <span v-if="passenger.certificateNo">证件号码：{{ passenger.certificateNo | codeMask({offset: 4, length: 10}) }}</span>
          </span>
        </div>
        <div class="pass-seg-list">
          <div class="seg-item" v-for="(seg, segIndex) in passenger.flightSegments" :key="segIndex">
            <div class="seg-col">
              <div class="seg-info">
                <div class="seg-info-base">
                  <div class="_base-col base-logo">
                    <div
                      v-if="seg.airline || seg.flightNo"
                      :class="[
                        'airline-logo',
                        'logo',
                        `logo-${seg.airline ? seg.airline?.toLocaleLowerCase() : seg.flightNo?.substring(0,2)?.toLocaleLowerCase() }`,
                      ]"
                    ></div>
                  </div>
                  <div class="_base-col base-dep">
                    <p class="base-strong base-time">
                      {{ moment(seg.departureTime).format("HH:mm") }}
                    </p>
                    <p class="base-bord base-city">
                      {{ seg | departureCity }}
                    </p>
                  </div>
                  <div class="_base-col base-flight">
                    <p class="flightNo">{{ seg.flightNo }}</p>
                    <div class="hr-line"></div>
                    <p class="airplane" v-if="seg.stopCityName">
                      经停：{{ seg | stopCity }}
                    </p>
                  </div>
                  <div class="_base-col base-arr">
                    <p class="base-strong base-time">
                      {{ moment(seg.arrivalTime).format("HH:mm") }}
                      <small
                        class="time-sup"
                        v-if="moment(seg.arrivalDate).isAfter(seg.departureDate)"
                        >+1</small
                      >
                    </p>
                    <p class="base-bord base-city">
                      {{ seg | arrivalCity }}
                    </p>
                  </div>
                  <div class="_base-col base-date">
                    <p class="_base-top">航班日期</p>
                    <p>{{ seg.departureTime | formatTime }}</p>
                  </div>
                  <div class="_base-col base-unit">
                    <p class="_base-top">舱位</p>
                    <p>{{ seg.cabin ?? '--' }}</p>
                  </div>
                  <div class="_base-col base-unit base-flightno">
                    <p class="_base-top">票号</p>
                    <p>
                      <span class="v-m">{{ passenger.ticketNo | formatTicketNo }}</span>
                    </p>
                  </div>
                  <!-- <div class="_base-col"></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { format } from '@/filters/time'
import codeMask from '@/assets/js/codeMask'

export default {
  name: 'accompany-ticket-list',
  props: {
    passengers: {
      type: Array,
      default: function () {
        return []
      }
    },
    order: {
      type: Object
    }
  },
  filters: {
    formatTime: format,
    discount (val) {
      const value = parseFloat(val)

      if (isNaN(value)) {
        return '-'
      }

      return value >= 1 ? '全价' : `${(value * 10).toFixed(1)}折`
    },
    stopCity (value) {
      const terminal = value.stopTerminal || ''
      return value.stopAirportName ? value.stopAirportName + terminal : '-'
    },
    arrivalCity (value) {
      const terminal = value.arrivalTerminal || ''
      return value.arrivalAirPortName ? value.arrivalAirPortName + terminal : '-'
    },
    departureCity (value) {
      const terminal = value.departureTerminal || ''
      return value.departureAirPortName ? value.departureAirPortName + terminal : '-'
    },
    formatTicketNo (value = '') {
      if (value.includes('-') || value.length !== 13) {
        return value
      } else {
        return value.substring(0, 3) + '-' + value.substring(3)
      }
    },
    codeMask
  }
}
</script>
<style lang="less" scoped>
.pass-seg-list{
  .seg-info-base {
    .base-logo {
      width: 140px;
      text-align: center;
      .airline-logo {
        display: inline-block;
      }
    }
    .base-city {
      min-width: 9em;
      width: auto;
    }
  }
}
</style>
